export default {
  title: {
    login: "%{school} - Accesso",
    registration: "%{school} - Registrazione",
    subjects: "%{school} - Seleziona materia",
    subject: "%{school} - Materia",
    offer: "%{school} - Offerta",
    home: "%{school} - Dashboard",
    dictionary: "%{school} - Dizionario",
    events: "%{school} - Eventi",
    news: "%{school} - Notizie",
    profile: "%{school} - Profilo",
    learn: "%{school} - Apprendimento",
    pay: "%{school} - Acquisto materia",
    checkInSystem: "Sei già registrato?",
    setPassword: "Inserisci la password per accedere.",
    createAccount: "Crea un account nel sistema.",
  },
  authCheckEmail: {
    title: "Inserisci la tua email",
    emailCaption: "Indirizzo email",
    continue: "Continua",
    or: "oppure",
  },
  authPassword: {
    title: "Accedi al tuo account",
    inputCaption: "Password",
    placeholder: "Inserisci la password",
    forgot: "Hai dimenticato la password?",
    submit: "Accedi",
  },
  authRegistration: {
    title: "Registrazione account",
    name: "Nome",
    phone: "Numero di telefono",
    password: "Crea una password",
    confirmPassword: "Ripeti la password creata",
  },
  totalError: "Ops, qualcosa è andato storto!",
  subjectChangeError: "Impossibile cambiare materia. Riprova o contatta la tua scuola.",
  email: "Email",
  personalLink: "Link personale",
  login: "Accesso",
  name: "Nome",
  firstLastName: "Cognome e nome",
  phone: "Telefono",
  formatPhone: "Numero di telefono nel formato 998...", // todo for leader-online
  aboutMe: "Su di me",
  fullAge: "La tua età (anni compiuti)",
  errorAge: "Età non corretta",
  notNumber: "Il valore deve essere un numero",
  registration: "Registrazione",
  password: "Password",
  currentPassword: "Password attuale",
  newPassword: "Nuova password",
  confirmPassword: "Conferma password",
  confirmNewPassword: "Conferma nuova password",
  forgotPassword: "Hai dimenticato la password?",
  passwordsMatch: "Le password non corrispondono",
  resetPassword: "Password reimpostata con successo, controlla la tua email per i dettagli.",
  resetConfirm: "Vuoi reimpostare la password?",
  enter: "Entra",
  studentEnter: "Accesso studente",
  check: "Controlla",
  signInWithGoogle: "Accedi con Google",
  emailIsNotRegistered: "Email non registrata",
  logout: "Esci",
  online: "online",
  offline: "offline",
  cancel: "Annulla",
  stop: "Ferma",
  no: "No",
  course: "Corso",
  dictionary: "Dizionario",
  events: "Eventi",
  news: "Notizie",
  words: "Parole",
  wordsAreHere: "Queste parole sono qui:",
  allWords: "Tutte le parole",
  phrases: "Frasi",
  videos: "Video",
  exercises: "Esercizi",
  theory: "Teoria",
  theoryAlt: "Appunti",
  theoryAdditionalFile: "Scarica file aggiuntivo (%{filename})",
  lessons: "Lezioni",
  topic: "Argomento",
  lesson: "Lezione",
  profile: "Profilo",
  orders: "Ordini",
  payment: "Pagamento",
  leaderboard: "Classifica",
  leaderboardPerDay: "Leader di oggi",
  time: "Tempo",
  points: "Punti",
  myPoints: "I miei punti per tutto il periodo",
  coins: "Monete",
  courses: "I miei corsi",
  loading: "Caricamento...",
  noTheory: "Nessuna teoria disponibile per questa lezione",
  startTraining: "Inizia allenamento",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Avvia una chat",
    startDialogTooltip: "Avvia una nuova conversazione",
    messages: "Messaggi",
    unreadOnly: "Solo non letti",
    delete: "Elimina",
    send: "Invia",
    sendHelper: "Ctrl+Invio per inviare un messaggio",
    close: "Chiudi",
    profile: "Profilo",
    lastActivity: "Ultima attività",
    status: "Stato",
    jobTitle: "Posizione lavorativa",
    tabLabel: "Chat",
    lastOnline: {
      time: "Ultimo accesso alle %{date}",
      weekday: "Ultimo accesso il %{date}",
      dayMonth: "Ultimo accesso il %{date}",
      monthYear: "Ultimo accesso a %{date}",
    },
    read: "Letto",
    errors: {
      wrongFormatting: "Il messaggio contiene una formattazione errata",
    },
  },
  branches: "Sezioni",
  easy: "Facile",
  expert: "Esperto",
  wordToLearn: "Parola da imparare",
  iKnowWord: "Conosco questa parola",
  videoVocabulary: "Vocabolario video",
  markVideoWatched: "Segna come guardato",
  videoWatched: "Guardato",
  passed: "superato",
  unsupportedExercise: "Esercizio non supportato (%{type})",
  changeCourse: "Cambia corso",
  currentCourse: "Corso attuale",
  allSubjects: "Tutte le materie",
  all: "Tutto",
  subject: "Materia",
  group: "Gruppo",
  start: "Inizia",
  chooseSubject: "Scegli la materia che vuoi studiare",
  hourValue: "%{value} h",
  completed: "Completato",
  notCompleted: "Non completato",
  paidBranch: "Questa sezione è a pagamento. Acquistala per studiare.",
  buyBranch: "Acquista la sezione per %{price} %{currency}",
  paidSubject: "Questa materia è a pagamento. Acquistala per studiare.",
  buySubject2: "Acquista la materia per %{price} %{currency}",
  decksItemNotOpen: "Per aprire questa lezione devi superare la lezione precedente",
  decksItemNotPurchasedBranch: "L'argomento di questa lezione è bloccato",
  decksItemNotOpenLevel: "Devi superare un livello precedente per aprire questa lezione",
  decksItemNotOpenBranch: "Per aprire questa lezione devi superare l'argomento precedente",
  deckAccessDenied: "Questa lezione non è ancora disponibile per te",
  openOnDate: "si aprirà il %{date}",
  levelAccessIsDenied: "I materiali di questo livello non sono disponibili per te",
  youAreDeactivated: "Il tuo account è stato disattivato, contatta la tua scuola",
  youAreDeactivatedShort: "Il tuo account è disattivato",
  youAreHaveNotPaidOffers: "Hai offerte non pagate",
  yourCertificates: "I tuoi certificati",
  emptyDeck: "Il mazzo è vuoto",
  nextDeck: "Lezione successiva",
  next: "Avanti",
  proceed: "Prosegui",
  skip: "Salta",
  more: "Altro",
  exit: "Esci",
  details: "Vedi dettagli",
  go: "Vai",
  profileEdit: "Modifica il profilo dell'utente",
  userInfo: "Informazioni utente",
  of: "di",
  back: "Indietro",
  levelPackExist: "Hai già questo set di livelli",
  awaitingPayment: "In attesa di pagamento",
  bought: "Acquistato",
  boughtUntilDate: "Acquistato fino al %{endDate}",
  availableUntilDate: "Disponibile fino al %{endDate}",
  showMore: "mostra di più",
  hide: "nascondi",
  communication: "Contattaci",
  askQuestion: "Fai una domanda",
  noDescription: "Descrizione mancante",
  description: "Descrizione:",
  onePerMonth: "1 al mese",
  semiannually: "Semestralmente",
  onceAYear: "Una volta all'anno",
  stopSubscribe: "Interrompi abbonamento",
  enable: "Attiva abbonamento",
  expired: "Scaduto",
  buySubject: "Acquista materia",
  buyOffer: "Acquista offerta",
  subscribeOffer: "Abbonati all'offerta",
  firstPayment: "Primo pagamento",
  accessDaysWarning: "%{smart_count} giorno rimasto |||| %{smart_count} giorni rimasti",
  accessDemoDaysWarning: "Demo: %{smart_count} giorno rimasto |||| Demo: %{smart_count} giorni rimasti",
  accessDemoButton: "Accesso demo",
  closeButton: "Chiudi",
  existOffer: "Esiste già un'offerta non pagata",
  loginInProcess: "accesso in corso...",
  done: "Completato:",
  Levels: {
    empty: "Al momento non ci sono livelli disponibili in questo corso.",
    name: "Livello:",
  },
  Decks: {
    scormPass: "Accredita una lezione",
    proceed: "Prosegui",
    stayHere: "Rimani qui",
  },
  Exercises: {
    tabTitle: "Esercizi",
    skip: "Avanti",
    check: "Controlla",
    examCheck: "Invia",
    typeAnswer: "Scrivi la tua risposta",
    next: "Avanti",
    rightAnswerWas: "La risposta corretta era:",
    showRightAnswer: "Mostra la risposta corretta",
    rightAnswer: "Risposta corretta:",
    congratulation: "Congratulazioni!",
    congratText: "Hai completato tutti gli esercizi di questa lezione!",
    wrongAnswer: "La tua risposta è sbagliata",
    answerSaved: "Risposta salvata",
    commentToAnswer: "Commento alla risposta selezionata:",
    appendix: {
      pdf: {
        tooltipButton: "Materiale aggiuntivo",
      },
    },
    type13: {
      title: "Completa gli spazi selezionando la parola corretta dall'elenco a discesa",
    },
    type12: {
      title: "Scopri maggiori informazioni",
    },
    type11: {
      title: {
        select: "Scegli la risposta giusta",
        keyboard: "Scrivi la risposta giusta",
      },
    },
    type9: {
      title: {
        select: "Completa gli spazi scegliendo le parole",
        keyboard: "Completa gli spazi",
      },
    },
    type8: {
      title: "Trova le corrispondenze",
    },
    type7: {
      title: {
        text: "Scrivi la tua risposta",
        audio: "Registra la tua risposta",
      },
      recordingIsNotSupported: "La registrazione audio non è supportata",
      audioRecordingError: "Si è verificato il seguente errore getUserMedia: ",
      inputLabel: "Messaggio",
      addPhotoVideo: "Aggiungi foto/video (max 5)",
      addPhoto: "Aggiungi foto/video (max 5)",
      cameraInitialization: "Inizializzazione...",
      change: "Cambia",
      codeToApprove: "Password",
      homework: {
        teacherData: {
          audio: "Commento audio dell'insegnante",
          audioComment: "Commento vocale dell'insegnante",
        },
      },
      addFiles: "Aggiungi file",
      limitsHelperText: "La lunghezza del testo deve essere di almeno %{count} lettere",
      photoRequired: "Allega almeno una foto o un file alla tua risposta",
      photoViewerHint: "Puoi ingrandire l'immagine con la rotella del mouse",
    },
    type6: {
      title: "Disegna la lettera",
      checkButtonText: "Capito!",
    },
    type3: {
      title: "Trascina e rilascia gli elementi nell'ordine corretto",
      hint: "Trascina qui gli elementi posizionati sotto",
    },
    type5: {
      title: "Seleziona gli elementi",
      hint: "Seleziona gli elementi corretti dalla parte inferiore dello schermo (per scegliere basta cliccarci sopra)",
    },
    type2: {
      title: "Scegli l'elemento mancante",
    },
  },
  Events: {
    headNotice: "L'orario dell'evento viene visualizzato in base al tuo fuso orario",
    title: "Eventi di questa settimana",
    startTime: "Ora di inizio",
    finishTime: "Ora di fine",
    group: "Gruppo",
    persons: "%{smart_count} persona |||| %{smart_count} persone",
    leader: "Responsabile",
    tag: "Tag",
    joinedCheckbox: "Solo iscritti",
    joined: "Iscritti:",
    interested: "Registrazione",
    registered: "Registrato",
    enter: "Entra",
    limitPopupInfo: "Hai raggiunto il limite di registrazioni",
    eventHasStarted: "L'evento è già iniziato!",
    registrationNotice: "Ti sei registrato con successo! Il pulsante di accesso sarà attivo il %{date_and_time}. Dopo questo orario non potrai annullare la registrazione all'evento",
    registrationNoticeNoUrl: "Ti sei registrato con successo! Dopo il %{date_and_time} non potrai annullare la registrazione all'evento",
    cancelRegistration: "Vuoi davvero annullare la registrazione?",
    calendarLink: "Aggiungi evento a Google Calendar",
    status_planned: "Pianificato",
    status_started: "Iniziato",
    status_completed_successfully: "Completato",
    status_last_minute_cancellation: "Annullato all'ultimo minuto",
    status_late_cancellation: "Annullamento tardivo",
    status_canceled: "Annullato",
    status_moved: "Rinviato",
  },
  statistic: {
    title: "Statistiche",
    points: "punti",
    phrases: "frasi",
    missions: "missioni",
    words: "parole",
    time: "tempo",
  },
  status: {
    wait_review: "Da revisionare",
    on_review: "In revisione",
    approved: "Approvato",
    not_approved: "Non approvato",
    not_approved_allow_update: "Non approvato (modifica consentita)",
    ai_reviewed: "Controllato con IA",
  },
  homeworks: {
    tabName: "Compiti",
    todo: "Da fare",
    done: "Fatto",
    topic: "Argomento",
    lesson: "Lezione",
    onlyInMobileApp: "Disponibile solo nell'applicazione mobile",
    todoHomework: "COMPITO IN ATTESA",
    postToDoButton: "Invia",
    types: {
      homework_todo: "Da fare",
      exercise: "Esercizio",
    },
    waitAIReview: "Attendi, l'IA sta controllando la risposta",
    dontWait: "non aspettare",
    checkingHomework: "Controllo del compito",
  },
  exam: {
    popupTitle: "Lezione con esame",
    popupDescr1: "Questa è una lezione con esame. Prima studia tutti i materiali aggiuntivi e solo dopo passa agli esercizi.",
    popupDescr2: `Non appena vai alla scheda "Esercizi", inizierà il conto alla rovescia.`,
    popupDescr3: 'Le schede "Teoria" e "Video" NON avviano il conto alla rovescia dell\'esame.',
    cancelButton: "La prossima volta",
    positiveButton: "Ho capito (%{smart_count} tentativo)  |||| Ho capito (%{smart_count} tentativi)",
    questions: "%{smart_count} domanda |||| %{smart_count} domande",
    oneAttempt: "Un tentativo per domanda",
    timeLimit: "Tempo limitato: %{limit} min",
    noPause: "L'esame non può essere messo in pausa",
    progress: "Domanda n. %{current} di %{total}",
    closeButton: "Chiudi",
    viewButton: "Vedi risultati",
    retakeButton: "Riprova (%{smart_count} tentativo)  |||| Riprova (%{smart_count} tentativi)",
    finishedPopupTitle: "Punteggio finale",
    examPassed: "Esame superato",
    examNotPassed: "Esame non superato",
    waitHomeworks: "%{smart_count} domanda in revisione |||| %{smart_count} domande in revisione",
    result: "Il tuo risultato:",
  },
  subjects: {
    unavailable: "La materia non è attualmente disponibile",
  },
  orderStatus: {
    approved: "Approvato",
    canceled: "Annullato",
    pending: "In attesa",
  },
  notificationsTypes: {
    event: "evento",
    invoice: "fattura",
    news: "notizie",
    homework: "compito",
    homework_todo: "compito_da_fare",
    type: {
      exercise: "Compito",
      homework_todo: "Compito da fare",
    },
  },
  notificationsAlert: {
    subscribe: "Attiva le notifiche",
    unsubscribe: "Disattiva le notifiche",
    instructions: "Clicca sul lucchetto 🔒 a sinistra della barra degli indirizzi e modifica l'autorizzazione delle notifiche come mostrato nell'immagine oppure cambia le impostazioni generali del browser.",
    permissionDefault: {
      title: "Iscriviti alle notifiche 🔔",
      body: "Avvisi sul cambio di stato dei compiti, sull'inizio degli eventi, sulle notizie e sui nuovi compiti da svolgere. Nessuna pubblicità, solo notifiche sul tuo apprendimento!",
    },
    permissionDenied: {
      title: "Le notifiche ora sono disattivate ❌",
      body: "Hai disattivato le notifiche in precedenza. Senza di esse non puoi sapere in tempo del cambio di stato dei compiti o dell'inizio di un evento. Per attivare le notifiche, segui le istruzioni qui sotto:",
    },
    permissionGranted: {
      title: "Le notifiche ora sono attivate ✔",
      body: "Sei sicuro di voler rinunciare alle notifiche? Senza di esse non puoi sapere in tempo del cambio di stato di un compito o dell'inizio di un evento. Per disattivare le notifiche, segui le istruzioni qui sotto:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Invia feedback",
    placeholder: "Raccontaci le tue impressioni",
    defaultInstruction: "Usa il cursore per valutare",
    eventInstruction: "Valuta com'è andato l'evento",
    submitError: "Seleziona una valutazione",
    submitSuccess: "Grazie! Il tuo feedback è stato inviato con successo",
    wasNotPresent: "Non ho partecipato all'evento",
    dateOfEvent: "Data dell'evento:",
  },
  congratulation: {
    mission: "Congratulazioni, la missione %{name} è completata!",
    missionTask: {
      title: "🎉 Congratulazioni! Compito %{name} completato.",
      content: "Mancano <b>%{need} compiti</b> per completare la missione — continua così!",
    },
  },
  accountNotFound: "Questo indirizzo email non è associato ad alcuno spazio di apprendimento. Contatta l'amministratore della tua scuola",
  demoAccess: "Vuoi provare SkillzRun per la tua azienda/scuola? Registrati per testare la piattaforma",
  structure: "Struttura",
  version: {
    message: "È disponibile una nuova versione dell'applicazione. Ricarica la pagina per aggiornare",
    button: "Ricarica",
  },
  missions: {
    title: "Missioni",
    startButton: "Avvia missione",
    missionStarted: "Missione iniziata %{started}",
    started: "Missione iniziata!",
    tasks: {
      title: "Dettagli del compito",
    },
  },
  productCatalog: {
    title: "Catalogo prodotti",
    coinBalance: "Il tuo saldo:",
    notEnoughCoins: "Monete insufficienti",
    order: "Ordine",
    orderConfirmation: "Conferma ordine",
    price: "Prezzo:",
    remaining: "Rimanenti:",
    instructionForForm: "Per velocizzare l'elaborazione del tuo ordine, compila i dati per la consegna.",
    address: "Indirizzo",
    thankText: "Grazie! Il tuo ordine è stato effettuato.",
    pleaseWait: "Attendi, un responsabile ti contatterà a breve.",
    pleaseWaitPersona: "Attendi un SMS. Riceverai il numero di tracciamento.",
    thankTextOffer: "Grazie! Il tuo acquisto è stato completato.",
    contentAvailableText: "Il contenuto è già disponibile: puoi utilizzarlo subito.",
    deliveryAddress: "Inserisci il tuo indirizzo di consegna",
    helperText: "Fornisci l'indirizzo completo oppure la città e il numero della filiale di Nova Poshta/Ukrposhta.",
    deliveryOptions: "*Le opzioni di consegna saranno confermate con il responsabile dopo la ricezione dell'ordine.",
    validationPhoneFormat: "Il numero di telefono deve contenere 10 cifre e iniziare con 0.",
    recipientNameLabel: "Nome completo",
    recipientNameRequired: "Inserisci il nome del destinatario.",
    npCityRequired: "Seleziona la città di consegna.",
    npWarehouseRequired: "Seleziona la filiale Nova Poshta.",
    npCityLabel: "Città Nova Poshta",
    npCityPlaceholder: "Inizia a digitare il nome della città",
    npCitySearching: "Ricerca delle città...",
    npCitySelectHint: "Seleziona una città dall'elenco",
    npCityTypeHint: "Inizia a digitare il nome della città (min. 3 caratteri)",
    npBranchTypeDepartments: "Filiali",
    npBranchTypePostomats: "Locker",
    npWarehouseLabel: "Filiale Nova Poshta",
    npWarehousePlaceholder: "Seleziona una filiale",
    npWarehouseLoading: "Caricamento delle filiali...",
    npWarehouseSelectHint: "Seleziona una filiale dall'elenco",
    npWarehouseEmpty: "Nessuna filiale trovata per questa città",
    npWarehouseCityFirst: "Seleziona prima una città",
    inProcessing: "In elaborazione",
    purchased: "Acquistato",
    oneTimeAlreadyPurchased: "Questo articolo è già stato acquistato",
  },
  companyReviewTitle: "Quanto è probabile che tu consigli la nostra scuola a un amico o conoscente?",
  companyReviewText: 'Valuta su una scala da 1 a 10, dove 1 significa "per niente probabile" e 10 significa "molto probabile"',
  subjectReviewTitle: "Quanto è stato interessante per te seguire questo corso sulla piattaforma?",
  subjectReviewText: 'Valuta su una scala da 1 a 10, dove 1 significa "per niente interessante" e 10 significa "molto interessante"',
  policySettings: {
    termsAndConditions: "Termini e condizioni",
    refund: "Informativa sulla privacy",
  },
  lessonsCount_one: "%{smart_count} lezione",
  lessonsCount_few: "%{smart_count} lezioni",
  lessonsCount_many: "%{smart_count} lezioni",
  promoCode: "Codice promozionale",
  promoInvalid: "Il codice promozionale non è valido",
};
